<style lang="scss" scoped>
/deep/ {
	.el-dialog {
		border-radius: 10px;
		padding: 15px;
		li {
			&.is-active {
				.el-carousel__button {
					background: #307fe2;
				}
			}
			.el-carousel__button {
				background-color: #c0c4cc;
				border: none;
				color: white;
				padding: 8px;
				text-align: center;
				text-decoration: none;
				display: inline-block;
				margin: 7px 7px;
				border-radius: 50%;
				height: auto;
				width: auto;
			}
		}
	}
}
.right {
	float: right;
}
img {
	width: 100%;
	max-height: 540px;
}
.main-text {
font-size:1.2rem !important;
}
.margin-top {
margin-top:50px;
}
</style>

<template lang="pug">
el-dialog(:visible.sync="dialogVisible" :before-close="handleClose" width="700px")
	el-carousel(height="460px", :autoplay="false", trigger="click")
		el-carousel-item(v-for="i in 6" :key="i")
			template(v-if="i === 1")
				h1.main-text Many schools still use csv files and manually update data in their apps...
				img(src="/static/img/wizard/step-1.svg", style="margin-top:30px")
				h1.right.main-text.margin-top ...this is time consuming and not a secure way to manage personal data
			template(v-if="i === 2")
				h1.main-text Introducing Wonde...
				img(src="/static/img/wizard/step-2.svg")
				h1.right.main-text ...the secure way for your school to manage data
			template(v-if="i === 3")
				h1.main-text It's simple to get started...
				img(src="/static/img/wizard/step-3.svg")
				h1.right.main-text ...select a pending app from your dashboard
			template(v-if="i === 4")
				h1.main-text Review the data they need to access...
				img(src="/static/img/wizard/step-4.svg")
				h1.right.main-text ...approve and then sit back
			template(v-if="i === 5")
				h1.main-text Your app will now be automatically kept up-to-date...
				img(src="/static/img/wizard/step-5.svg")
				h1.right.main-text ...and your data is now securely managed!
				div(style="text-align:center; margin-top:20px; clear:both")
			template(v-if="i === 6")
				div(style="text-align:center; margin-top:160px; clear:both")
					h2 Now you know the basics,<br> you can now start managing your applications.
					el-button(type='primary' v-on:click="handleClose") Get started
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			dialogVisible: true,
		};
	},
	computed: {
		dialogHeight() {
return			500;
		},
	},
	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						is_admin
						seen_admin_wizard_at
						School {
							id
							sso_enabled
							shard_id
						}
					}
				}
			`,
			update: (r) => r.User,
		},
	},
	methods: {
		handleClose() {
			try {
				this.$apollo.mutate({
					mutation: gql`
						mutation SeenAdminWizard {
							SeenAdminWizard {
								id
								seen_admin_wizard_at
							}
						}
					`,
					optimisticResponse: {
						__typename: "Mutation",
						SeenAdminWizard: {
							__typename: "User",
							id: this.User.id,
							seen_admin_wizard_at: new Date(),
						},
					},
				});
			} catch (e) {
				// Fail silently
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/modals/Dialog.vue